import ProLayout from '@ant-design/pro-layout';
import { TdsFooterLite } from '@tencent/tds-ui';
import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import BuglyIcon from '@/assets/images/public/bugly2.0.react.svg?react';
import { isInternal } from '@/infrastructure/auth';
import { useAuthContext } from '@/presentation/hooks';
import { AvatarMenu } from '@/presentation/layouts/header/avatar';
import styles from './index.module.scss';


export const LiteLayout: FC<{showAvatar?: boolean}> = (props) => {
  const { authInfo } = useAuthContext();
  const { showAvatar = true } = props;

  const headerContentRender = () => (authInfo.isLoggedIn ? (
      <Row className="bugly-header-extra">
        <Col span={12}>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          {showAvatar && <AvatarMenu />}
        </Col>
      </Row>
  ) : null);

  return (
    <ProLayout
      navTheme="light"
      layout="mix"
      headerTheme="light"
      fixSiderbar
      fixedHeader
      menuRender={false}
      headerContentRender={headerContentRender}
      logo={<Link to={'/index/main'}><BuglyIcon /></Link>}
      className={styles.lite}
      title={''}
    >
      <div className={styles.content}>
        {props.children}
        <TdsFooterLite isTdsQQ={isInternal()} privacyPolicyUrl={'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56'} />
      </div>
    </ProLayout>
  );
};
